import { FormInputs, HeadlineType } from '../types';
import { generateHeadlines as generateTemplateHeadlines } from './headlineGenerator';
import OpenAI from 'openai';
import { AI_MODELS } from './aiModels';

export async function generateAIHeadlines(
  inputs: FormInputs,
  apiKey: string,
  modelId: string
): Promise<HeadlineType[]> {
  // If no API key provided, fall back to template generation
  if (!apiKey) {
    return generateTemplateHeadlines(inputs);
  }

  const model = AI_MODELS.find(m => m.id === modelId);
  if (!model || model.provider !== 'openai') {
    return generateTemplateHeadlines(inputs);
  }

  try {
    const openai = new OpenAI({
      apiKey,
      dangerouslyAllowBrowser: true
    });

    const completion = await openai.chat.completions.create({
      messages: [{ 
        role: "system", 
        content: `Generate 10 engaging headlines for a ${inputs.audience}-level ${inputs.platform} post about "${inputs.topic}" targeting the keyword "${inputs.keyword}". The content goal is ${inputs.goal} and the industry is ${inputs.industry}. Include a mix of styles: informative, curiosity-driven, and problem-solving. Format each headline on a new line.`
      }],
      model: modelId,
    });

    const headlines = completion.choices[0].message.content?.split('\n').filter(Boolean) || [];
    
    return headlines.map(title => ({
      title,
      metrics: {
        emotional: Math.floor(Math.random() * 3) + 7,
        curiosity: Math.floor(Math.random() * 3) + 7,
        ctr: Number((Math.random() * 2 + 3).toFixed(1)),
        seo: Math.floor(Math.random() * 3) + 7,
      }
    }));
  } catch (error) {
    // Fallback to template generation on error
    return generateTemplateHeadlines(inputs);
  }
}